module.exports = __webpack_public_path__ + "media/images/gallery/constellations/auriga/aur_dir-73e8f79e4b7a432299497dcc494749db.gif";